export type ButtonVariant = 'filled' | 'outline' | 'dashed' | 'ghost';
export type ButtonColor = 'primary' | 'secondary' | 'warning' | 'success';

export const ACTION_BUTTON_STYLES: Record<ButtonVariant, Record<ButtonColor, string>> = {
  filled: {
    primary: 'bg-ptTeal text-white hover:bg-ptTeal-100 active:bg-ptTeal-100',
    secondary: 'bg-gray-200 text-gray-700 hover:bg-gray-300 active:bg-gray-300',
    warning: 'bg-red-500 text-white hover:bg-red-700 active:bg-red-700',
    success: 'bg-green-500 text-white hover:bg-green-700 active:bg-green-700',
  },
  outline: {
    primary: 'border-2 border-ptTeal text-ptTeal hover:border-ptTeal-100 hover:text-ptTeal-100',
    secondary: 'border-2 border-gray-200 text-gray-700 hover:border-gray-300 hover:text-gray-800',
    warning: 'border-2 border-red-500 text-red-500 hover:border-red-700 hover:text-red-700',
    success: 'border-2 border-green-500 text-green-500 hover:border-green-700 hover:text-green-700',
  },
  dashed: {
    primary: 'border-2 border-dashed border-ptTeal text-ptTeal hover:border-ptTeal-100 hover:text-ptTeal-100',
    secondary: 'border-2 border-dashed border-gray-200 text-gray-700 hover:border-gray-300 hover:text-gray-800',
    warning: 'border-2 border-dashed border-red-500 text-red-500 hover:border-red-700 hover:text-red-700',
    success: 'border-2 border-dashed border-green-500 text-green-500 hover:border-green-700 hover:text-green-700',
  },
  ghost: {
    primary: 'text-ptTeal rounded hover:bg-gray-200 hover:text-ptTeal-100',
    secondary: 'text-gray-700 rounded hover:bg-gray-200 hover:text-gray-800',
    warning: 'text-red-500 rounded hover:bg-gray-200 hover:text-red-700',
    success: 'text-green-500 rounded hover:bg-gray-200 hover:text-green-700',
  },
};
